export default __webpack_public_path__ + "static/media/plus.4e06646a.svg";